  <div class="site-list boxed with-title small">
    <div class="list-item">
      <div class="title text-primary" i18n="@@account.bankDetails.bankName">Bank Name</div>
      <div class="text">
        <ng-container *ngIf="data?.bankName">{{data?.bankName}}</ng-container>
        <ng-container *ngIf="!data?.bankName" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
    <div class="list-item">
      <div class="title text-primary" i18n="@@account.bankDetails.iban">IBAN</div>
      <div class="text">
        <ng-container *ngIf="data?.iban">{{data?.iban}}</ng-container>
        <ng-container *ngIf="!data?.iban" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
    <div class="list-item">
      <div class="title text-primary" i18n="@@account.bankDetails.accountNumber">Account Number</div>
      <div class="text">
        <ng-container *ngIf="data?.accountNumber">{{data?.accountNumber}}</ng-container>
        <ng-container *ngIf="!data?.accountNumber" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
    <div class="list-item">
      <div class="title text-primary" i18n="@@bankDetailsForm.swift.label">SWIFT</div>
      <div class="text">
        <ng-container *ngIf="data?.swiftCode">{{data?.swiftCode}}</ng-container>
        <ng-container *ngIf="!data?.swiftCode" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
    <div class="list-item">
      <div class="title text-primary" i18n="@@account.bankDetails.branchName">Branch Name</div>
      <div class="text">
        <ng-container *ngIf="data?.branchName">{{data?.branchName}}</ng-container>
        <ng-container *ngIf="!data?.branchName" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
    <div class="list-item">
      <div class="title text-primary" i18n="@@account.bankDetails.branchAddress">Branch Address</div>
      <div class="text">
        <ng-container *ngIf="data?.branchAddress">{{data?.branchAddress}}</ng-container>
        <ng-container *ngIf="!data?.branchAddress" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
    <div class="list-item">
      <div class="title text-primary" i18n="@@account.bankDetails.accountHolderLegalName">Full Legal Name</div>
      <div class="text">
        <ng-container *ngIf="data?.accountHolderLegalName">{{data?.accountHolderLegalName}}</ng-container>
        <ng-container *ngIf="!data?.accountHolderLegalName" i18n="@@account.bankDetails.empty">Not Set</ng-container>
      </div>
    </div>
  </div>
<div class="w-100 d-flex flex-column align-items-center mt-2">
  <a href="#" (click)="correctBankDetails($event)" i18n="@@addBank.incorrect.link">These details are incorrect</a>
  <button (click)="continueDataHandling()" class="btn btn-block btn-primary mt-3" i18n="@@addBank.continue">Continue</button>
</div>
